// Implements: F-ITK-007
/**
 * `/whatsapp` — the person's WhatsApp linking section (UIX.4, design 12.13).
 *
 * The page only composes: the reads, the code and the removals live in the `intake` module's
 * `WhatsAppLinkingContainer`. The person is the session's, and the container is keyed by that
 * person's id (checklist 14): another person signing in on the same tab mounts a fresh one, with
 * no code of the previous person in its state. While intake is disabled the address is the
 * not-found page, as an unknown address would be.
 */

import type { ReactElement } from "react";

import { WhatsAppLinkingContainer } from "../../modules/intake/containers/WhatsAppLinkingContainer";
import { useSession } from "../../shared/api/session";
import { NotFoundPage } from "./NotFoundPage";

export function WhatsAppPage(): ReactElement | null {
  const { state } = useSession();
  // `RequireSession` renders this page only for a session; nothing to show otherwise.
  if (state.status !== "authenticated") return null;
  const { user, scopes } = state.view;

  return <WhatsAppLinkingContainer key={user.id} personId={user.id} scopes={scopes} whenDisabled={<NotFoundPage />} />;
}
